module.exports = __webpack_public_path__ + "static/media/7-15.85fa6405.mp3";